export enum PaymentMethodKeyEnum {
  Unipaas = 'UNIPAAS',
  AptPay = 'APTPAY_ACH',
  PaymentIQ = 'PAYMENTIQ',
  WorldPayCNPCard = 'WORLDPAYCNP_CARD',
};